import { useEffect, useState } from "react";
import { configurationServices } from "../../constants/configurationServices";

export default function Health() {
    const [isHealthy, setIsHealthy] = useState(false);

    const fetchJson = async () => {
        try {
            const res = await fetch(configurationServices().health);
            if (!res.ok) throw new Error("Service call failed");

            setIsHealthy(true);
        } catch (error) {
            console.error("Service call failed");
            setIsHealthy(false);
        }
    };

    useEffect(() => {
        fetchJson();
    }, []);

    return (
        <div>
            {isHealthy && <h3>HealthCheck</h3>}
        </div>
    );
}
